<template>
    <Modal>
        <template #header>
            <p class="tiw__step__successfulEvaluation__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__successfulEvaluation__title") }}
            </p>
            <p>
                {{
                    useTranslate(
                        TIWStore.domainIsAvoAfrica
                            ? "tiw__successfulEvaluation__subtitle__avoAfrica"
                            : "tiw__successfulEvaluation__subtitle",
                    )
                }}
            </p>
        </template>

        <HandedDevice
            :device-price="HowYouRateDeviceStore.handedDevicePrice"
            :device-chain="ChooseDeviceStore.deviceChain"
            :device-state="!HowYouRateDeviceStore.isBack && HowYouRateDeviceStore.rate"
            :device-preview="ChooseDeviceStore.deviceImagePreview"
            :device-grade="null"
            :device-no-grade="false"
            :device-terminated="false"
        />

        <div class="tiw__step__successfulEvaluation">
            <form name="successfulEvaluationForm">
                <!-- FIXME v-if - это костыль. Вся функциональность сейчас заточена под то, чтобы у нас было injected устройство. Скорее всего, будем менять функциональность, чтобы виджет работал без injected устройства. -->
                <CalculatedDevice
                    :calculated-data="HowYouRateDeviceStore.calculatedDeviceData"
                    v-if="!TIWStore.domainIsTakealot && TIWStore.INJECTED_GOOD"
                />
                <!-- Поле "IMEI" -->
                <Field :is-error="!EnterImeiValidation.status">
                    <template #title>
                        <span v-if="ChooseDeviceStore.isImei">
                            {{ useTranslate("tiw__enterImei__imei") }}
                        </span>
                        <span v-else>
                            {{ useTranslate("tiw__enterImei__serial") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="currentDeviceValue"
                            type="text"
                            name="imei"
                            :disabled="!TIWStore.isDiscountLater || loadingToNext"
                            inputmode="numeric"
                            maxlength="15"
                        />
                    </template>
                </Field>
                <div
                    v-if="TIWStore.DISCOUNT_LATER"
                    class="tiw__step__successfulEvaluation__imei__infoBlock"
                >
                    <Button
                        color="link"
                        variant="link"
                        type="button"
                        class="tiw_fs-12"
                        @click="showInfoAboutImei"
                    >
                        <span>
                            {{
                                useTranslate(
                                    howFindImeiBlock ? "tiw__hide" : "tiw__enterImei__howFindImei",
                                )
                            }}
                        </span>
                    </Button>
                    <div v-if="howFindImeiBlock" class="tiw__step__enterImei__info">
                        <h3 class="tiw__title">
                            {{ useTranslate("tiw__enterImei__howFindImei") }}
                        </h3>
                        <ul class="tiw__ul tiw__ul_disc tiw_fs-14">
                            <li v-html="useTranslate('tiw__enterImei__howFindImei_step1')" />
                            <li>
                                {{ useTranslate("tiw__enterImei__howFindImei_step2") }}
                            </li>
                        </ul>
                        <div class="tiw__step__enterImei__info__images">
                            <figure class="tiw_tc">
                                <img
                                    width="100%"
                                    :src="`${pathToImages}/img/iphone_imei_1.webp`"
                                    alt="iPhone dial *#06#"
                                />
                            </figure>
                            <figure class="tiw_tc">
                                <img
                                    width="100%"
                                    :src="`${pathToImages}/img/iphone_imei_2.webp`"
                                    alt="iPhone dial *#06#"
                                />
                            </figure>
                        </div>
                    </div>
                </div>
                <!-- Поле "ФИО" -->
                <Field :is-error="!fioValidation.status">
                    <template #title>
                        <span>
                            {{
                                useTranslate(
                                    TIWStore.isDiscountLater
                                        ? "tiw__successfulEvaluation__contact_title"
                                        : "tiw__successfulEvaluation__fio_title",
                                )
                            }}
                        </span>
                    </template>
                    <template #hintTop>
                        <span>
                            {{
                                useTranslate(
                                    TIWStore.locationIsZA
                                        ? "tiw__successfulEvaluation__fio_location-za"
                                        : "tiw__successfulEvaluation__fio",
                                )
                            }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.fio"
                            type="text"
                            name="fio"
                            maxlength="50"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!fioValidation.status" #hintBottom>
                        <span>
                            {{ fioValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "ИНН" -->
                <Field
                    v-if="!TIWStore.locationIsZA && !TIWStore.isDiscountLater"
                    :is-error="!innValidation.status"
                >
                    <template #hintTop>
                        <span v-if="TIWStore.locationIsMD">
                            {{ useTranslate("tiw__successfulEvaluation__idnp") }}
                        </span>
                        <span v-else>
                            {{ useTranslate("tiw__successfulEvaluation__inn") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.inn"
                            type="text"
                            name="fio"
                            :maxlength="TIWStore.locationIsMD ? 13 : 12"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!innValidation.status" #hintBottom>
                        <span>
                            {{ innValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "ID Number" -->
                <Field
                    v-if="TIWStore.locationIsZA || TIWStore.locationIsMD"
                    :is-error="!docNumValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__id_number") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-if="TIWStore.locationIsZA"
                            v-model="SuccessfulEvaluationStore.fields.docNum"
                            type="text"
                            name="docNum"
                            maxlength="13"
                            :disabled="loadingToNext"
                        />
                        <Input
                            v-else
                            v-model="SuccessfulEvaluationStore.fields.docNum"
                            v-maska="seriasAndNumberMDMaskOption"
                            type="text"
                            name="docNum"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docNumValidation.status" #hintBottom>
                        <span>
                            {{ docNumValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Номер квартиры" -->
                <Field
                    v-if="TIWStore.locationIsZA || TIWStore.locationIsMD"
                    :is-error="!docApartmentNumValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__apartment") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docApartmentNum"
                            type="text"
                            name="docApartmentNum"
                            :disabled="loadingToNext"
                            :placeholder="useTranslate('tiw__notRequired')"
                        />
                    </template>
                    <template v-if="!docApartmentNumValidation.status" #hintBottom>
                        <span>
                            {{ docApartmentNumValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Номер дома" -->
                <Field
                    v-if="TIWStore.locationIsZA || TIWStore.locationIsMD"
                    :is-error="!docHouseNumValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__house") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docHouseNum"
                            type="text"
                            name="docHouseNum"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docHouseNumValidation.status" #hintBottom>
                        <span>
                            {{ docHouseNumValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Suburb/ District" -->
                <Field v-if="TIWStore.locationIsZA" :is-error="!docDistrictValidation.status">
                    <template #hintTop>
                        <span>
                            {{ "Suburb / District" }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docDistrict"
                            type="text"
                            name="docDistrict"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docDistrictValidation.status" #hintBottom>
                        <span>
                            {{ docDistrictValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Postal Code" -->
                <Field v-if="TIWStore.locationIsZA" :is-error="!docPostCodeValidation.status">
                    <template #hintTop>
                        <span>
                            {{ "Postal Code" }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docPostCode"
                            type="text"
                            name="docPostCode"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docPostCodeValidation.status" #hintBottom>
                        <span>
                            {{ docPostCodeValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Street Name / Name of farm" -->
                <Field
                    v-if="TIWStore.locationIsZA || TIWStore.locationIsMD"
                    :is-error="!docStreetValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__street") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docStreet"
                            type="text"
                            name="docStreet"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docStreetValidation.status" #hintBottom>
                        <span>
                            {{ docStreetValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "City / Town" -->
                <Field
                    v-if="TIWStore.locationIsZA || TIWStore.locationIsMD"
                    :is-error="!docCityNameValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__city") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.docCityName"
                            type="text"
                            name="docCityName"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!docCityNameValidation.status" #hintBottom>
                        <span>
                            {{ docCityNameValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Field "Passport series and number" -->
                <Field v-if="TIWStore.locationIsUA && !TIWStore.isDiscountLater" :is-error="false">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__passportSeriesNumber") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.passportSeriesNumber"
                            type="text"
                            name="docNum"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="false" #hintBottom>
                        <span>
                            {{ "error" }}
                        </span>
                    </template>
                </Field>

                <!-- Field "Passport Issue Date" -->
                <Field
                    v-if="TIWStore.locationIsUA && !TIWStore.isDiscountLater"
                    :is-error="!passportIssueDateValidation.status"
                >
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__passportIssueDate") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.passportIssueDate"
                            v-maska="passportIssueDateMaskOptions"
                            type="text"
                            name="docIssueDate"
                            :placeholder="TIWStore.passportIssueDateMask"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!passportIssueDateValidation.status" #hintBottom>
                        <span>
                            {{ passportIssueDateValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "E-mail" -->
                <Field :is-error="!emailValidation.status">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__email") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.email"
                            type="text"
                            name="email"
                            :placeholder="emailFieldPlaceholder"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!emailValidation.status" #hintBottom>
                        <span>
                            {{ emailValidation.message }}
                        </span>
                    </template>
                </Field>

                <!-- Поле "Телефон" -->
                <Field :is-error="!phoneValidation.status">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__successfulEvaluation__phone") }}
                        </span>
                    </template>
                    <template #body>
                        <Input
                            v-model="SuccessfulEvaluationStore.fields.phone"
                            v-maska="phoneMaskOptions"
                            type="text"
                            name="phone"
                            :placeholder="TIWStore.phoneMaskPlaceholder"
                            :disabled="loadingToNext"
                        />
                    </template>
                    <template v-if="!phoneValidation.status" #hintBottom>
                        <span>
                            {{ phoneValidation.message }}
                        </span>
                    </template>
                </Field>
                <!-- Чекбокс "Персональные данные" -->
                <Checkbox
                    v-model="SuccessfulEvaluationStore.fields.personal"
                    :checked="SuccessfulEvaluationStore.fields.personal"
                >
                    <span v-html="useTranslate(checkboxPersonalHtml)" />
                </Checkbox>
                <Checkbox
                    v-if="TIWStore.isDiscountLater"
                    v-model="iAgreeToReceiveNewsletter"
                    :checked="iAgreeToReceiveNewsletter"
                >
                    {{ useTranslate("tiw__agreeReceiveNewsletter") }}
                </Checkbox>
                <Checkbox
                    v-if="TIWStore.locationIsZA"
                    v-model="SuccessfulEvaluationStore.fields.vatForm"
                    :checked="SuccessfulEvaluationStore.fields.vatForm"
                >
                    {{ useTranslate("tiw__successfulEvaluation__VAT__form") }}
                </Checkbox>
                <!-- Чекбокс "Я обязуюсь" -->
                <Checkbox
                    v-if="!TIWStore.isDiscountLater"
                    v-model="SuccessfulEvaluationStore.fields.duty"
                    :checked="SuccessfulEvaluationStore.fields.duty"
                >
                    <span>
                        {{ useTranslate("tiw__successfulEvaluation__checkbox_duty_head") }}:
                    </span>
                    <ul class="tiw__step__successfulEvaluation__checkbox_duty_list">
                        <li>
                            {{ useTranslate("tiw__successfulEvaluation__checkbox_duty_step1") }}
                        </li>
                        <li>
                            {{ useTranslate("tiw__successfulEvaluation__checkbox_duty_step2") }}
                        </li>
                        <li>
                            {{ useTranslate("tiw__successfulEvaluation__checkbox_duty_step3") }}
                        </li>
                    </ul>
                    <span>
                        {{ useTranslate("tiw__successfulEvaluation__checkbox_duty_footer") }}
                    </span>
                </Checkbox>
            </form>

            <p
                class="tiw__step__successfulEvaluation__warn"
                v-html="useTranslate('tiw__successfulEvaluation__warn')"
            />

            <div class="tiw_group tiw_group-sb">
                <!-- <Button
                    type="button"
                    variant="skeleton"
                    class="tiw__step__successfulEvaluation__btn-back"
                    @click="onRestart"
                >
                    <RefreshIcon />
                    <span>Начать заново</span>
                </Button> -->
                <Button
                    type="button"
                    class="tiw__step__successfulEvaluation__btn-next tiw__btn-next"
                    :disabled="!isAcceptedToNext || loadingToNext"
                    :loading="loadingToNext"
                    @click="TIWStore.isDiscountLater ? finishWithoutDiscount() : clickToNext()"
                >
                    <span>
                        {{ useTranslate(continueText) }}
                    </span>
                </Button>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "SuccessfulEvaluation",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [SuccessfulEvaluation]
 * Модальное окно / экран "Ура! Все готово!"
 */

import type { MaskInputOptions } from "maska";

import { vMaska } from "maska/vue";
import { ref, computed, reactive, watch } from "vue";

import CalculatedDevice from "@/components/calculatedDevice/calculatedDevice.vue";
import HandedDevice from "@/components/handedDevice/handedDevice.vue";
import Modal from "@/components/modal/modal.vue";
import { PARTNERS_DOMAINS } from "@/constants";
import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import { createContract, type CreateContractPayload, setDeviceStatus } from "@/helpers/singingType";
import createApplication from "@/hooks/requests/createApplication/createApplication";
// import it4CreateContract from "@/hooks/requests/it4CreateContract/it4CreateContract";
import { useAnalyticsEventAgreement } from "@/hooks/useAnalytics/useAnalytics";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import useValidate from "@/hooks/useValidate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useEvaluationResultStore } from "@/stores/evaluationResult/evaluationResult";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useSuccessfulEvaluationStore } from "@/stores/successfulEvaluation/successfulEvaluation";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import Checkbox from "@/ui/checkbox/checkbox.vue";
import Field from "@/ui/field/field.vue";
import AwardIcon from "@/ui/icons/award.vue";
import Input from "@/ui/input/input.vue";
import { deviceGradeIsEquals } from "~/tiw/helpers/deviceGrade";
import parseStringPrice from "~/tiw/helpers/parseStringPrice";
import apiApply from "~/tiw/hooks/requests/apiApply/apiApply";
import it4UpdateIMEI from "~/tiw/hooks/requests/it4UpdateIMEI/it4UpdateIMEI";
import useStoreResetter from "~/tiw/hooks/useStoreResetter/useStoreResetter";
import { I_WIDGET_STEPS } from "~/tiw/stores/tiw/tiw.types";

const pathToImages = import.meta.env.VITE_APP_URL;

const TIWStore = useTIWStore();
const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const ChooseDeviceStore = useChooseDeviceStore();
const howFindImeiBlock = ref<boolean>(false);
const iAgreeToReceiveNewsletter = ref<boolean>(false);

const currentDeviceValue = computed(() =>
    ChooseDeviceStore.isImei
        ? ChooseDeviceStore.field_imei.value
        : ChooseDeviceStore.field_serial.value,
);

const showInfoAboutImei = () => {
    howFindImeiBlock.value = !howFindImeiBlock.value;
};

const checkboxPersonalHtml = computed<string>(() => {
    if (TIWStore.locationIsMD) {
        return "tiw__successfulEvaluation__checkbox_personal__md";
    }

    if (TIWStore.locationIsGE) {
        return "tiw__successfulEvaluation__checkbox_personal__ge";
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.COMFY) {
        return "tiw__successfulEvaluation__checkbox_personal__ua_comfy";
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.BREEZY_UA) {
        return "tiw__successfulEvaluation__checkbox_personal__ua_breezy";
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.FOXTROT) {
        return "tiw__successfulEvaluation__checkbox_personal__ua_foxtrot";
    }

    if (
        TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.AVO_AFRICA ||
        TIWStore.domainIsTakealot
    ) {
        return "tiw__successfulEvaluation__checkbox_personal__za_avo_africa";
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.DG_CO_ZA) {
        return "tiw__successfulEvaluation__checkbox_personal__za_dg_co";
    }

    return "tiw__successfulEvaluation__checkbox_personal";
});

watch(checkboxPersonalHtml, () => console.log("test====================", checkboxPersonalHtml));

// Валидация поля "ИНН"
const innValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.inn) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: TIWStore.locationIsMD ? "idnp" : "inn",
        value: SuccessfulEvaluationStore.fields.inn,
    });
    return valiDate;
});

// Валидация поля "passport issue date"
const passportIssueDateValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.passportIssueDate) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: "human-date",
        value: SuccessfulEvaluationStore.fields.passportIssueDate,
    });
    return valiDate;
});

const EnterImeiValidation = computed(() => {
    if (!currentDeviceValue.value) {
        return {
            status: true,
            message: "ok",
        };
    }
    const validate = useValidate({
        target: ChooseDeviceStore.isImei ? "imei" : "serial",
        value: currentDeviceValue.value,
    });
    return validate;
});

const docNumValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docNum) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: TIWStore.locationIsZA ? "id-number--location-za" : "serias-and-number-md",
        value: SuccessfulEvaluationStore.fields.docNum,
    });
    return valiDate;
});

const docApartmentNumValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docApartmentNum) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docApartmentNum.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

const docHouseNumValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docHouseNum) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docHouseNum.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

const docDistrictValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docDistrict) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docDistrict.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

const docPostCodeValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docPostCode) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docPostCode.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

const docStreetValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docStreet) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docStreet.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

const docCityNameValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.docCityName) {
        return {
            status: true,
            message: "ok",
        };
    }
    return {
        status: SuccessfulEvaluationStore.fields.docCityName.length > 0,
        message: useTranslate("tiw__validation__required"),
    };
});

// Валидация поля "ФИО"
const fioValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.fio) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: "fio",
        value: SuccessfulEvaluationStore.fields.fio,
    });
    return valiDate;
});

// Валидация поля "email"
const emailValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.email) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: "email",
        value: SuccessfulEvaluationStore.fields.email,
    });
    return valiDate;
});

// Валидация поля "Телефон"
const phoneValidation = computed(() => {
    if (!SuccessfulEvaluationStore.fields.phone) {
        return {
            status: true,
            message: "ok",
        };
    }
    const valiDate = useValidate({
        target: "phone",
        value: SuccessfulEvaluationStore.fields.phone,
    });
    return valiDate;
});

// Маска автозаполнение номера телефона поля "Телефон"
const phoneMaskOptions = reactive<MaskInputOptions>({
    mask: TIWStore.phoneMask,
    tokens: {
        _: {
            pattern: /[0-9]/,
        },
        A: {
            pattern: /[1-9]/,
        },
    },
    eager: true,
});

// Маска автозаполнение номера телефона поля "Дата выдачи"
const passportIssueDateMaskOptions = reactive<MaskInputOptions>({
    mask: TIWStore.passportIssueDateMask,
    tokens: {
        _: {
            pattern: /[0-9]/,
        },
    },
    eager: true,
});

const seriasAndNumberMDMaskOption = reactive<MaskInputOptions>({
    mask: TIWStore.seriasAndNumberMDMask,
    tokens: {
        Z: {
            pattern: /[a-zA-Z]/,
            transform: (value) => value.toUpperCase(),
        },
        _: {
            pattern: /[0-9]/,
        },
    },
    eager: true,
});

const emailFieldPlaceholder = computed(() => {
    if (SuccessfulEvaluationStore.isEmailRequired) {
        return "";
    }

    return useTranslate("tiw__notRequired");
});

const isAcceptedToNext = computed<boolean>(() => {
    let fields = [fioValidation.value, innValidation.value];

    // need refactor
    const isImeiExits = currentDeviceValue.value.length > 0;

    if (TIWStore.locationIsZA) {
        fields = [fioValidation.value];
    }

    if (TIWStore.locationIsMD) {
        fields = [
            ...fields,
            docNumValidation.value,
            docCityNameValidation.value,
            docStreetValidation.value,
            docHouseNumValidation.value,
            docApartmentNumValidation.value,
        ];
    }

    if (TIWStore.isDiscountLater) {
        fields.push(EnterImeiValidation.value);
    }
    if (SuccessfulEvaluationStore.isEmailRequired) {
        fields.push(emailValidation.value);
    }

    const validationStatus = fields.every((el) => el.status);

    return validationStatus && SuccessfulEvaluationStore.isAcceptedToNext && isImeiExits;
});

const loadingToNext = ref<boolean>(false);

const continueText = computed<string>(() => {
    if (TIWStore.isDiscountLater) {
        return "tiw__successfulEvaluation__send__application";
    } else {
        if (TIWStore.domainIsTakealot) {
            return "tiw__successfulEvaluation__receivingViaSMS";
        }

        if (TIWStore.domainIsOrangeMD) {
            return "tiw__finishEntry";
        }

        if (HowYouRateDeviceStore.chosenSigningType === "TRUSTME_KZ") {
            return "tiw__successfulEvaluation__toContract";
        }

        if (HowYouRateDeviceStore.chosenSigningType === "WITHOUT_SMS") {
            return "tiw__addToCart__addToCart";
        }

        if (HowYouRateDeviceStore.chosenSigningType === "SCRIVE") {
            return "tiw__addToCart__addToCart";
        }

        return "tiw__successfulEvaluation__continue";
    }
});

const finishWithoutDiscount = async () => {
    const findActionSale =
        HowYouRateDeviceStore.registeringDeviceData.buyoutTopUp.specialGrading[0]?.grades?.find(
            (el) => deviceGradeIsEquals(el.gradeCode, HowYouRateDeviceStore.grade),
        );

    await it4UpdateIMEI({
        article: TIWStore.INJECTED_GOOD?.article ?? "",
        token: TIWStore.WIDGET_DATA.token,
        imei: currentDeviceValue.value,
        deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
    });

    await apiApply({
        form_name: "application_form",
        referer: "widget",
        code: TIWStore.WIDGET_DATA.code,
        token: TIWStore.WIDGET_DATA.token,
        locale: TIWStore.standardizedLocale,
        device_price: HowYouRateDeviceStore.calculatedDeviceData.panelCost,
        product_name: HowYouRateDeviceStore.calculatedDeviceData.panelTitle,
        email: SuccessfulEvaluationStore.fields.email,
        name: SuccessfulEvaluationStore.fields.fio,
        phone: SuccessfulEvaluationStore.fields.phone,
        device_imei: currentDeviceValue.value,
        legal_code_iin: SuccessfulEvaluationStore.fields.inn,
        r_city: SuccessfulEvaluationStore.fields.docCityName,
        top_up_activity: findActionSale
            ? HowYouRateDeviceStore.registeringDeviceData.buyoutTopUp.specialGrading[0].name
            : null,
        top_up_price: HowYouRateDeviceStore.calculatedDeviceData.panelActionSale
            ? String(
                  parseStringPrice(
                      HowYouRateDeviceStore.calculatedDeviceData.panelActionSale.actionSale,
                  ),
              )
            : null,
    });

    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
    TIWStore.switchStep("chooseDevice");
    TIWStore.closeWidget();
};

const clickToNext = async () => {
    loadingToNext.value = true;

    useAnalyticsEventAgreement();

    let nextStep: I_WIDGET_STEPS = "addToCart";

    let createContractPayload: CreateContractPayload = {
        token: TIWStore.WIDGET_DATA.token,
        deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
        lang: TIWStore.standardizedLocale,
        firstName: SuccessfulEvaluationStore.destructuredFio.firstName,
        lastName: SuccessfulEvaluationStore.destructuredFio.lastName,
        middleName: SuccessfulEvaluationStore.destructuredFio.middleName,
        mobile: SuccessfulEvaluationStore.fields.phone,
        doc: SuccessfulEvaluationStore.fields.inn,
        docNum: SuccessfulEvaluationStore.fields.passportSeriesNumber,
        docIssueDate: SuccessfulEvaluationStore.fields.passportIssueDate,
        email: SuccessfulEvaluationStore.fields.email,
    };

    if (HowYouRateDeviceStore.chosenSigningType === "SCRIVE" || TIWStore.locationIsMD) {
        createContractPayload = {
            ...createContractPayload,
            docNum: SuccessfulEvaluationStore.fields.docNum,

            docApartmentNum: SuccessfulEvaluationStore.fields.docApartmentNum,
            docHouseNum: SuccessfulEvaluationStore.fields.docHouseNum,
            docDistrict: SuccessfulEvaluationStore.fields.docDistrict,
            docPostCode: SuccessfulEvaluationStore.fields.docPostCode,
            docStreet: SuccessfulEvaluationStore.fields.docStreet,
            docCityName: SuccessfulEvaluationStore.fields.docCityName,
        };
    }

    if (HowYouRateDeviceStore.chosenSigningType === "WITHOUT_SMS") {
        await setDeviceStatus({
            token: TIWStore.WIDGET_DATA.token,
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            status: "ONLINE_CONTRACT_GENERATED",
        });

        nextStep = "signingWithoutSms";
    }

    SuccessfulEvaluationStore.contractData = await createContract(createContractPayload);

    if (TIWStore.domainIsOrangeMD) {
        try {
            const address =
                `${SuccessfulEvaluationStore.fields.docStreet} ${SuccessfulEvaluationStore.fields.docHouseNum}, apt. ${SuccessfulEvaluationStore.fields.docApartmentNum}`.trim();

            await createApplication({
                device_id: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                ex_id: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                imei: currentDeviceValue.value,
                locale: TIWStore.standardizedLocale,
                location: TIWStore.WIDGET_DATA.location,
                source: TIWStore.WIDGET_DATA.code,
                phone: SuccessfulEvaluationStore.fields.phone.replace(/\D+/g, ""),
                city_name: SuccessfulEvaluationStore.fields.docCityName,
                email: SuccessfulEvaluationStore.fields.email,
                first_name: SuccessfulEvaluationStore.destructuredFio.firstName,
                last_name: SuccessfulEvaluationStore.destructuredFio.lastName,
                grade: HowYouRateDeviceStore.registeringDeviceData.grade,
                brand: ChooseDeviceStore.brandName,
                model: ChooseDeviceStore.field_model.value.name,
                price: parseStringPrice(HowYouRateDeviceStore.handedDevicePrice),
                address,
            });
        } catch (e) {
            useBugTracker(
                "Successful Evaluation --- [POST] Create Application",
                BugTrackerSection.ERROR,
                {
                    message: e?.message,
                },
            );
            loadingToNext.value = false;
            return;
        }
    }

    loadingToNext.value = false;

    TIWStore.switchStep(nextStep);
};
</script>

<style lang="scss" src="./successfulEvaluation.scss"></style>
